import React, { useState } from "react";
import { useTransition, animated } from "react-spring";
import ProgressBar from "../../ProgressBar";
import { stepStyles } from "../formStyles";

export const GeneralContractor = ({ formData, setForm, navigation, step }) => {
  const [error, setError] = useState(false);
  const [isVisible] = useState(true);

  const transition = useTransition(isVisible, {
    from: { opacity: 0, transform: "translate3d(500px,0px,0)" },
    enter: { opacity: 1, transform: "translate3d(0,0px,0)" },
  });

  const generalContractor = [
    { id: "Has General Contractor/Builder", title: "Yes" },
    {
      id: "Still Looking for General Contractor/Builder",
      title: "Not yet, still looking",
    },
    {
      id: "will not get a contractor/builder",
      title: "I will not be working with a general contractor/builder",
    },
  ];

  const checkForNextStep = () => {
    if (formData.generalContractor === "") {
      setError(true);
      console.log("error");
    }
    if (formData.generalContractor !== "") {
      navigation.next();
      console.log("next");
    }
  };

  return (
    <div className={stepStyles.page}>
      <ProgressBar width={"10%"} />
      <div className={stepStyles.content}>
        {transition((style, item) =>
          item ? (
            <animated.div style={style} className={stepStyles.panel}>
              <h1 className={stepStyles.title}>Are you already working with a builder/contractor?</h1>
              <div className="w-full">
                <label className="text-base font-medium text-gray-900"></label>
                <fieldset className="">
                  <legend className="sr-only">Are you already working with a builder/contractor?</legend>
                  <div className={stepStyles.optionGroup}>
                    {generalContractor.map((generalContractorDescription) => (
                      <label key={generalContractorDescription.id} className={stepStyles.optionRow}>
                        <input
                          onChange={setForm}
                          value={generalContractorDescription.id}
                          id={generalContractorDescription.id}
                          name="generalContractor"
                          type="radio"
                          className={stepStyles.radio}
                        />
                        <span className={stepStyles.label}>{generalContractorDescription.title}</span>
                      </label>
                    ))}
                  </div>
                  {error ? <p className={stepStyles.error}>please fill out an answer</p> : null}
                </fieldset>
              </div>
            </animated.div>
          ) : null,
        )}
      </div>
      <div className={stepStyles.actionBar}>
        <div className={stepStyles.actionRow}>
          <div className="w-full md:w-auto">
            <button className={`${stepStyles.button} w-full`} onClick={() => checkForNextStep()}>
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
